enum ClientTypes {
    CLIENT = 'client',
    PROSPECT = 'prospect',
    RESERVE = 'reserve',
    PEU_INTERESSANT = 'peu-interessant',
    PROPOSITION = 'proposition'
  }

export default ClientTypes;
